import { api } from './client';
import type { User, UserCreateRequest, UserUpdateRequest } from '../types';

export const usersApi = {
  list: (storeId?: number | null) =>
    api
      .get<User[]>('/users', {
        params: storeId != null ? { storeId } : undefined,
      })
      .then((r) => r.data),

  create: (body: UserCreateRequest) =>
    api.post<User>('/users', body).then((r) => r.data),

  update: (id: number, body: UserUpdateRequest) =>
    api.put<User>(`/users/${id}`, body).then((r) => r.data),
};
